import { pipe } from 'fp-ts/lib/function';
import { failure, parse, string, success } from 'io-ts/Decoder';

/**
 * A push subscription id is not a UUID: `PushSubscriptionDBService` derives it
 * from the subscription details as `push-subscription:<sha256 hex>`, so the
 * same browser subscription always maps to the same id. The digest is matched
 * exactly — no trailing content — like every other prefixed id.
 */
const reSubscriptionId = /^push-subscription:[0-9a-f]{64}$/;

export const Id = pipe(
	string,
	parse((s) => success(s.toLowerCase())),
	parse((s) =>
		reSubscriptionId.test(s) ? success(s) : failure(s, 'a valid push-subscription id')
	)
);
